// extracted by mini-css-extract-plugin
module.exports = {"card":"Category_card__1EJO6","cardCont":"Category_cardCont__2yhNA","posn":"Category_posn__2nNnC","heading":"Category_heading__3kVWp"};